import { useState } from 'react';
import { Text, View } from '@smarterservices/smarter-ui';
import Loader from '@ui/context/session/components/Common/Loader';
import TimeRemaining from '../../Common/TimeRemaining';
import BaseOverlay from './BaseOverlay';

const SessionDisconnected = ({ lastConnectionChange }) => {
  const mustReconnectBy = lastConnectionChange?.metadata?.mustReconnectBy;
  const [hasExpired, setHasExpired] = useState(false);

  const handleExpire = () => {
    setHasExpired(true);
  };

  return (
    <BaseOverlay>
      <View as="div" textAlign="center">
        {mustReconnectBy && !hasExpired && (
          <>
            <Loader size="large" text="Session Disconnected" />
            <Text as="div" size="small" color="secondary" margin="small none none none">
              Must reconnect within <TimeRemaining until={new Date(mustReconnectBy)} onExpires={handleExpire} />
            </Text>
          </>
        )}
        {hasExpired && (
          <Text as="div" size="small" color="danger" margin="small none none none">
            Reconnect Time Expired, session preparing to end.
          </Text>
        )}
      </View>
    </BaseOverlay>
  );
};

export default SessionDisconnected;
